import React from 'react';

import ActionText from './ActionText';
import Graph from './Graph';
import FinalText from './FinalText';
import Headline from './Headline';
import FullReportCta from './FullReportCta';

import styles from './styles.css';

const ResultsContainer = ({ assignedResponse, responsePoints }) => {
  const { resultAsDecimal, resultAsPercentage } = responsePoints;

  return (
    <div className={styles.container}>
      <Headline headline={assignedResponse} resultValue={resultAsDecimal} />
      <ActionText goodGuyPercent={resultAsPercentage} />
      <Graph percentFilled={resultAsDecimal} />
      <FinalText goodGuyPercent={resultAsPercentage} />
      <FullReportCta />
    </div>
  );
};

export default ResultsContainer;



// WEBPACK FOOTER //
// ./src/components/ResultsContainer/index.js